import {
  UpdateCustomerNotificationInput,
  UpdpateCustomerGeneralSettingsInput,
} from "shared";
import { axiosClient } from "utilz";

export const getCustomerGeneralSettings = async (customerId: string) => {
  try {
    const url = `/v2/customers/${customerId}/settings/general`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const updateCustomerGeneralSettings = async ({
  bodyData,
  customerId,
}: {
  bodyData: UpdpateCustomerGeneralSettingsInput;
  customerId: string | undefined;
}) => {
  try {
    const url = `/v2/customers/${customerId}/settings/general`;
    const response = await axiosClient.patch(`${url}`, bodyData);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.success;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
